export const moneyFormat = (amount: number, lang: string, marketType: 'USA' | 'CAN'): string => {
  try {
    return new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'fr-FR', {
      style: 'currency',
      currency: marketType === 'CAN' ? 'CAD' : 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      // @ts-ignore
      currencyDisplay: 'narrowSymbol',
    }).format(amount);
  } catch (e) {
    // IOS Safari 14 does not support currencyDisplay: 'narrowSymbol'
    return new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'fr-FR', {
      style: 'currency',
      currency: marketType === 'CAN' ? 'CAD' : 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      // @ts-ignore
      currencyDisplay: 'symbol',
    }).format(amount);
  }
};

export const moneyParse = (price: string): number => {
  // FR format
  if (!price?.startsWith('$')) return Number(price?.replace(',', '.').replace(/[^0-9.-]+/g, ''));

  // EN format
  return Number(price?.replace(/[^0-9.-]+/g, ''));
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatPrice = (
  price: number | null | undefined,
  shouldBeNegative?: boolean,
): string => {
  if (!price) return '—';
  const formatted = formatter.format(price);
  if (price > 0 && shouldBeNegative) {
    return `-${formatted}`;
  }
  return formatted;
};
